import { imagesDb } from 'database/db'

export const saveImageToDb = async (filename: string, content: Blob) => {
  try {
    imagesDb.dcaImages.put({ fileName: filename, data: content })
    return { success: true }
  } catch (error) {
    console.error('saveImageToDb:', error)
    throw error
  }
}
